import CommonUtil from "./utility";
export const StorageUtil = {
    saveData(key, data) {
        localStorage.setItem(key, data);
    },
    saveObject(key, data) {
        if (CommonUtil.isNotNull(data)) {
        this.saveData(key, JSON.stringify(data));
    }
    },
    getData(key) {
        return localStorage.getItem(key);
    },

    getObject(key) {
        let obj = this.getData(key);
        if (CommonUtil.isNotNull(obj)) {
            return JSON.parse(obj);
        }
    },

    removeData(key) {
        localStorage.removeItem(key);
    },

    removeAll() {
        localStorage.clear();
    },

    hasKey(key) {
        return CommonUtil.isNotNull(localStorage.getItem(key));
    }
};

export default StorageUtil;